import React from 'react'

const SubmitLoader = () => {
    return (
        <div className="submit-loader ms-2"></div>
    )
}

export default SubmitLoader